/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import { useSelector } from "../../store";

export const useUser = () => useSelector((state) => state.auth.user);
